import React, { useState, useEffect } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Text, Button } from "@izettle/react"

import { Cancel } from "@/components/cancel"
import { Error } from "@/components/error"
import { PageWrapper } from "@/components/layout-helpers"
import { useSetPageTitle } from "@/components/page-title/hook"
import { PreviewImage } from "@/components/preview-image"
import { baseUrl } from "@/constants"
import { File } from "@/models"

import { DocumentIsUploading } from "./document-is-uploading"
import { UploadingCompleted } from "./uploading-completed"

const PageTitle = styled(Text.Title3)`
  text-align: center;
  margin: ${spacing.small} ${spacing.none} ${spacing.xxSmall} ${spacing.none};
`

const InfoText = styled(Text.Regular)`
  text-align: center;
  margin: ${spacing.none} ${spacing.none} ${spacing.small} ${spacing.none};
`

type UploadProps = {
  file: File | undefined
  isUploading: boolean
  successfullySubmittedToBackend: boolean
  upload: () => void
}

export const Upload: React.FC<UploadProps> = ({
  file,
  isUploading,
  successfullySubmittedToBackend,
  upload,
}) => {
  const [previewImgURL, setPreviewImgURL] = useState<string>("")
  const [isPDF, setIsPDF] = useState<boolean>(false)
  const { text } = useLocalization()
  const { setPageTitle } = useSetPageTitle()

  useEffect(() => {
    setPageTitle(text("PROOF_OF_ADDRESS"))
  }, [])

  useEffect(() => {
    if (file) {
      if (file.type === "application/pdf") {
        setIsPDF(true)
        upload()
      }

      setPreviewImgURL(URL.createObjectURL(file))
    }
  }, [file])

  if (!previewImgURL) {
    return <Error cancelUrl={`${baseUrl}/proofOfAddress`} />
  }

  if (isUploading) {
    return <DocumentIsUploading file={file} isPDF={isPDF} previewImgURL={previewImgURL} />
  }

  if (!isUploading && successfullySubmittedToBackend) {
    return <UploadingCompleted file={file} isPDF={isPDF} previewImgURL={previewImgURL} />
  }

  return (
    <PageWrapper>
      <Cancel url={`${baseUrl}/proofOfAddress`} />
      <PageTitle>{text("CONFIRM_UPLOAD_TITLE")}</PageTitle>
      <InfoText>{text("CONFIRM_UPLOAD_TEXT")}</InfoText>
      <PreviewImage alt={file?.name} imgUrl={previewImgURL} isPDF={isPDF} />
      <Button onClick={upload}>{text("PURPOSE_SUBMIT_BUTTON")}</Button>
    </PageWrapper>
  )
}
